export default ({ value, options = [] }) => {
  const dic = options.filter(d => d.id === value || d.value === value)[0];
  return (
    <span className="TUI-Dicionary">{dic ? dic.name || dic.text : value}</span>
  );
};
